export default __webpack_public_path__ + "static/media/kabeko_illu_5.a0fec1fe.png";